import { render, staticRenderFns } from "./SplitScroll.vue?vue&type=template&id=26f7862a"
import script from "./SplitScroll.vue?vue&type=script&lang=js"
export * from "./SplitScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports